import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProjectStatus } from '@paragon/contract-library';

/** Matches projects with no assignee; `null` already means no assignee filter. */
export const UNASSIGNED = '__none__';

export interface ProjectFiltersState {
  readonly search: string;
  /** Selected month as a 'YYYY-MM' string, or null for no date filter. */
  readonly createdMonth: string | null;
  readonly status: ProjectStatus | null;
  /** A member's email, `UNASSIGNED`, or null for anyone. */
  readonly assignee: string | null;
}

const initialProjectFiltersState: ProjectFiltersState = {
  search: '',
  createdMonth: null,
  status: null,
  assignee: null,
};

const projectFiltersSlice = createSlice({
  name: 'projectFilters',
  initialState: initialProjectFiltersState,
  reducers: {
    searchChanged: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    createdMonthChanged: (state, action: PayloadAction<string | null>) => {
      state.createdMonth = action.payload;
    },
    statusChanged: (state, action: PayloadAction<ProjectStatus | null>) => {
      state.status = action.payload;
    },
    assigneeChanged: (state, action: PayloadAction<string | null>) => {
      state.assignee = action.payload;
    },
    filtersCleared: () => initialProjectFiltersState,
  },
});

export const { searchChanged, createdMonthChanged, statusChanged, assigneeChanged, filtersCleared } =
  projectFiltersSlice.actions;
export const projectFilters = projectFiltersSlice.reducer;
